import { ShieldCheck, Clock, XCircle, PauseCircle } from "lucide-react";

export const LABEL = { pending: "Waiting for payment", active: "Active", cancelling: "Cancelled — perks until period end", cancelled: "Cancelled", paused: "Paused", deactivated: "Billing problem" };

export const isLive = (m) => m.live ?? (m.status === "active" || m.status === "cancelling");

/** Icon, colour, eyebrow label and headline for the membership page header. */
export function statusPresentation(m) {
  const live = isLive(m);
  const fallback = LABEL[m.status] || m.status;
  if (m.status === "pending") return { live, Icon: Clock, tone: "text-amber-400", label: fallback, title: "Almost there." };
  if (m.status === "paused" && !live) return { live, Icon: PauseCircle, tone: "text-amber-300", label: fallback, title: `Hi ${m.name}, your ${m.tier_name} is paused.` };
  if (live) return { live, Icon: ShieldCheck, tone: "text-[#FFD600]", label: m.status === "paused" ? "Active · free month" : fallback, title: `Hi ${m.name}, you're a ${m.tier_name} member.` };
  return { live, Icon: XCircle, tone: "text-rose-400", label: fallback, title: `${m.tier_name} — ${fallback}.` };
}
